export const ABORT_SIGNAL_NAME = {
  orderingContextAutocompleteAddress: 'orderingContext::autocompleteAddress',
  orderingContextFetchOrders: 'orderingContext::fetchOrders',
};
